/**
 * @namespace Abstracts
 */
import Backbone from 'backbone'
import UUID from '../../../libs/uuid'

/**
 * Modelo da Tarefa
 * @name Task
 * @memberof abstracts/tasks
 * @extends Backbone.Model
 * @see {@link https://backbonejs.org/#Model}
 */
class Task extends Backbone.Model {
    /**
     * Inicializa o model
     * O método add da collection foi sobrescrito e salvará um atributo 0 e/ou 1
     * Esse método verifica a presença desses atributos
     * Atribui corretamente com os metodos waiting e execute
     * Por fim removendo os atributos 0 e 1 caso exista
     *
     * @return {void}
     */
    initialize () {
        // Define um id único
        this.set('id', UUID())

        // Existe apenas um parâmetro
        if (this.get(0) && !this.get(1)) {
            this.set('waiting', false)
            this.set('execute', this._configExecutes(this.get(0)))
        }

        // Existem dois parâmentros
        if (this.get(0) && this.get(1)) {
            this.set('waiting', this.get(0))
            this.set('execute', this._configExecutes(this.get(1)))
        }

        // Deleta os parâmetros provisórios
        this.unset(0)
        this.unset(1)
    }

    /**
     * Configura o atributo de execuções
     * Se não for um array o transforma.
     *
     * @return {void}
     */
    _configExecutes (executes) {
        if (!Array.isArray(executes)) {
            return [executes]
        }

        return executes
    }

    /**
     * Valida os valores do model
     * Não utilizado ainda
     *
     * @return {void}
     */
    validate () {
        // return (() => {
        //     const errors = [];

        //     if(!this.get("entities") && !this.get("event")) {
        //         errors.push("É necessário enviar um array de entidades ou um evento");
        //     }

        //     if(!this.get("callback") && !this.get("script"))  {
        //         errors.push("É necessário enviar um callback");
        //     }

        //     console.log(errors);

        //     if (errors.length > 0) {
        //         return errors;
        //     }
        // })();
    }
}

export default Task
